import { useSelector } from 'react-redux';
import { useQuery } from '../../routes';
import { fromSubscription } from '../../store';
import { SubscriptionLegacy } from './SubscriptionLegacy';
import { SubscriptionV2 } from './SubscriptionV2';
import { useLaunchDarkly } from '../../launchdarkly';

export const Subscription = () => {
  const { get } = useQuery();
  const accountId = Number(get('accountId'));
  const subscription = useSelector(fromSubscription.selectTrueSubscriptions());
  const { flags } = useLaunchDarkly();
  if (subscription && flags?.truePlatformEnabled) {
    return <SubscriptionV2 subscription={subscription} accountId={accountId} />;
  }

  return <SubscriptionLegacy />;
};
